//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import '@polymer/paper-progress/paper-progress.js'
import '@polymer/paper-icon-button/paper-icon-button.js';

export default {
  name: "ProgressBar",
  props: {
    status: {
      type: Object,
    }
  },

  data: () => ({
    _id: {
      type: String,
    },
    actionName: 'refresh',
    modelName: 'NONAME',
    currentState: 'UNKNOWN',
    processedCounter: -1,
    totalCounter: -1,
    progressValue: 0,
    errorProgress: 0,
    errorCounter: 0,
    disableBtn: false
  }),

  watch: {
    status: function (oldVal, newVal) {
      this._id = newVal.id;
      this.modelName = newVal.id;
      this.currentState = newVal.state;
      this.totalCounter = newVal.total;
      this.errorCounter = newVal.errorCount;
      this.processedCounter = newVal.processed;
    },

    currentState: function (oldVal, newVal) {
      switch (newVal) {
        case 'SCHEDULED':
        case 'SCROLLING_RUNNING':
        case 'RUNNING':
          this.disableBtn = false;
          this.actionName = 'cancel';
          break;
        case 'COMPLETED':
          this.disableBtn = false;
          this.actionName = 'refresh';
          break;
        case 'ABORTED':
          this.disableBtn = true;
          this.actionName = 'refresh';
          break;
        default:
          /* NOP */
      }
    },

    processedCounter: function (oldVal, newVal) {
      if (this.totalCounter < 1 || newVal < 1) {
        return 0;
      }

      this.progressValue = (newVal * 100) / this.totalCounter - this.errorCounter;
      this.errorProgress = this.progressValue + this.errorCounter;
    }
  },

  methods: {
    _run() {
      let action = null;
      let op = null;
      switch (this.currentState) {
        case 'SCHEDULED':
        case 'SCROLLING_RUNNING':
        case 'RUNNING':
          op = this.$refs.aiExportInterrupt;
          action = 'Interrupt';
          break;
        case 'COMPLETED':
          action = 'Restart';
          op = this.$refs.aiExportRestart;
          break;
        default:
          this.$toasted.show(`Cannot run an operation with state: ${this.currentState}`, {duration: 2000});
          return;
      }

      op.params = {
        commandId: this._id,
      };

      op.execute()
          .then((response) => {
            this.$toasted.show(`Successfully performed ${action}`, {duration: 2000});
            return response.value;
          })
          .catch(() => {
            this.$toasted.show(`Could not perform ${action}`, {duration: 2000});
          });
    },
  }
}
